const cappasityEmbedList = async (productId) => {
  if (typeof Shopify === "undefined" || !Shopify.shop) {
    console.warn("Shopify object is not available.");
    return;
  }
    
  if (!productId) {
    console.warn("Product ID is not provided.");
    return;
  }
    
  const data = await fetch(
    `/apps/cappasity/embed-list?productId=${productId}`
  );

  const response = await data.json();

  console.log(response);

  if (
    response &&
    response.length > 0 &&
    response[0].playerHTML &&
    response[0].imageId
  ) {
    const $productElement = document.querySelector(
      `[data-image-id="${response[0].imageId}"]`
    );
    if (!$productElement) {
      console.warn("Product element not found for Cappasity embed.");
      return;
    }
    if ($productElement) {
      $productElement.firstElementChild.innerHTML = response[0].playerHTML;
    }
  } else {
    console.warn("No Cappasity embeds found for this product.");
  }
};

cappasityEmbedList(productId)